export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f06de7b5d30923036276b713717e15baa2eb259c8&name=fetchTypeahead!'